import "./Home.module.css";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import SectorsWePower from "./sections/SectorsWePower";
import FrontierExpertise from "./sections/FrontierExpertise";
import ReadyMadeWalkingScenarios from "./sections/ReadyMadeWalkingScenarios";
import MetroRideInNumbers from "./sections/MetroRideInNumbers";
import JoinTheMovement from "./sections/JoinTheMovement";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navbar />
      <Hero />
      <SectorsWePower />
      <FrontierExpertise />
      <ReadyMadeWalkingScenarios />
      <MetroRideInNumbers />
      <JoinTheMovement />
      <FooterInfo />
    </div>;
}